import React from 'react';
import { useTranslation } from 'react-i18next';

export default function UrpassInfo() {
  const [t] = useTranslation('global');

  return (
    <>
      <p className="pt-1 pb-1 instructions ion-text-center">{t('urpass.info')}</p>
    </>
  );
}
